import React from "react";
import Logo from "../../components/Logo";
import { useNavigate } from "react-router-dom";

function ForgotPassword() {
  const navigate = useNavigate();
  const handleSubmit = () => {
    navigate("/code");
  };
  return (
    <div className="">
      <div className="h-screen w-full bg-white dark:bg-black   grid place-content-center  ">
        <div className="h-full w-full  p-10 flex space-x-20">
          <div className="">
            <div className="mb-20">
              <Logo />
            </div>

            <div className="">
              <div className="text-[76px]  font-sans hidden md:block ">
                <h1 className="text-[#2A71E8] text-[70px]  font-sans  ">
                  Lets
                </h1>
                <h1 className="flex space-x-2  text-[#2A71E8]  text-[70px] font-sans ">
                  Get<span className="ml-3 text-[#be2117]"> Started...</span>
                </h1>
              </div>
            </div>
            <button className="bg-gradient-to-b from-[#BE2117] to-[#09062C] rounded-[20px] p-4  px-11 text-white  w-[240px]">
              TRANSLATE
            </button>
          </div>

          <div className="h-full sm:bg-[#f4f4f4] rounded-[50px] w-80 dark:bg-[#33333347] sm:shadow-xl    pb-10">
            <div className="flex justify-center">
              <div className="border-2 border-[#5D5FEF] w-14 mt-3"></div>
            </div>

            <div className="flex flex-col items-center  px-12 mt-28">
              <div className="space-y-3">
                <p className="font-[600]">Forgot Password</p>
                <p className=" text-[11px] font-[400]">
                  Enter your email for the verification process, We will send 4
                  digits code to your email.
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center  px-12 mt-20">
              <div className="space-y-3s">
                <p className="font-[400] text-[12px] mb-3">Email</p>

                <div
                  className="w-52 boder border-[#D9D9D] rounded-[25px] bg-[#D9D9D9] dark:bg-[#33333347]  h-[30px] mb-10

"
                >
                  <input
                    type="email"
                    className=" w-full  focus:outline-none boder  dark:bg-[#33333347]   rounded-[25px] bg-[#D9D9D9] h-[30px] px-2"
                  />
                </div>

                <button
                  onClick={handleSubmit}
                  className="w-52 boder border-[#D9D9D] rounded-[25px] bg-[#2A71E8] h-[px] text-white p-1 text-[15px] "
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
